import { useQuery } from '@tanstack/react-query';
import { paymentOptions } from '../../constants/payments';
const LIVE_POLL_INTERVAL_MILLISECONDS = 3_000;
const getRefetchInterval = (payments) => payments?.[0]?.status === 'pending' ? LIVE_POLL_INTERVAL_MILLISECONDS : false;
/**
 * Finds the payment by the ID its gateway assigned (e.g. Paynow's `paymentId`
 * in the return URL) and keeps polling while it is still `pending` — the
 * gateway's notification may reach the backend after the user is redirected back.
 */
export function usePaymentByExternalIdLive(externalPaymentId) {
    const { data, isLoading, isError } = useQuery(paymentOptions.get({ externalPaymentId }, undefined, {
        enabled: externalPaymentId !== undefined,
        refetchInterval: getRefetchInterval,
    }));
    return {
        payment: data?.[0],
        loadingPayment: isLoading,
        paymentLookupFailed: isError,
    };
}
